import type { IssueMediaVisibilityChangeRequestAction } from '../../../actions/issue/media/index.tsx';
import type { State } from '../../../reducers/types.tsx';

export const issueMediaVisibilityChange =
	(eventPrefix: string) =>
	(preState: State, state: State, action: IssueMediaVisibilityChangeRequestAction) => {
		const { issueId, isVisible } = action.payload;
		return {
			name: `${eventPrefix}.card.media.toggled.card`,
			data: {
				issueId,
				enabled: isVisible,
			},
		};
	};
